<div class="modal-header">
  <div class="modal-title">Transfer Report</div>
  <button type="button" class="close" id="prepared-modal-close" aria-label="Close" (click)="decline()">
    <span aria-hidden="true"></span>
  </button>
</div>

<div class="modal-body">
  <div class="row text-center font-italic">
    <p class="col-md-12 font-size-20">
      This operation will completely remove the Report from your Dashboard and Transfer all information to the selected user. This action is irreversible.
    </p>
  </div>

  <form #transferForm="ngForm" novalidate="novalidate" autocomplete="off">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group"
             [ngClass]="{'error-block' : ((!EMAIL.valid && !EMAIL.untouched) || transferForm?.submitted) && (EMAIL.errors?.required || EMAIL.errors?.pattern)}">
          <div class="label">Please enter an existing Valzy user Email to whom you would like to Transfer this Report:</div>
          <input type="text" class="input input__large input__blue" [(ngModel)]="NEW_EMAIL"
                 placeholder="hello@mail.com" name="EMAIL" required restrictFirstSpace
                 [ngClass]="{'error-input' : ((!EMAIL.valid && !EMAIL.untouched) || transferForm?.submitted) && (EMAIL.errors?.required || EMAIL.errors?.pattern)}"
                 [pattern]="commonService.emailPattern"
                 id="EMAIL" #EMAIL="ngModel" autocomplete="new-password" (ngModelChange)="removeErrorMsg()" />
          <ng-container
            *ngIf="((!EMAIL.valid && !EMAIL.untouched) || transferForm?.submitted) && (EMAIL.errors?.required || EMAIL.errors?.pattern)">
            <div *ngIf="EMAIL.errors?.required" class="error-text">Email is required</div>
            <div *ngIf="!EMAIL.errors?.required && EMAIL.errors?.pattern" class="error-text">The email
              you entered isn’t correct. Please check your email.
            </div>
          </ng-container>
          <ng-container *ngIf="error">
            <div class="error-text">{{error}}</div>
          </ng-container>
        </div>
      </div>
    </div>
  </form>

</div>

<div class="modal-footer">
  <button type="button" id="prepared-modal-cancel" class="button secondary__button large__button"
          (click)="decline()">Cancel
  </button>
  <button type="button" id="prepared-modal-continue" class="button primary__button large__button"
          (click)="callUpdateGroupAPI()" [disabled]="!transferForm.valid">Transfer
  </button>
</div>
